import { Usuario } from "./usuario.model";
import { Faturamento } from "./faturamento.model";

export class Cliente {
    id: number;
    apelido: string = '';
    razaoSocial: string = '';
    cpfCnpj: string = '';
    telefone: string = '';
    email: string = '';
    tipoLogradouro: string = '';
    inscricaoMunicipal: string = '';
    logradouro?: string = '';
    numero?: string = '';
    complemento?: string = '';
    bairro?: string = '';
    municipio?: string = '';
    codigoMunicipio: string = '';
    uf?: string = '';
    cep?: string = '';
    pais?: string = '';
    usuarioId: string = '';
    usuario: Usuario = new Usuario();
    faturamentosId: Faturamento[] = [];
}
